<template>
	<div :class="{ 'ellipsis-loader': true }">
		<div class="ellipsis-loader__dot" :style="[spinnerStyle]"></div>
		<div class="ellipsis-loader__dot" :style="[spinnerStyle]"></div>
		<div class="ellipsis-loader__dot" :style="[spinnerStyle]"></div>
		<div class="ellipsis-loader__dot" :style="[spinnerStyle]"></div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
@Options({
	props: {
		/** Включить */
		color: { type: String, default: "#ffffff" },
	},
})
export default class EllipsisLoader extends Vue {
	public color: string;

	public get spinnerStyle(): object {
		return {
			background: this.color,
		};
	}
}
</script>

<style scoped lang="scss">
.ellipsis-loader {
	display: inline-block;
	position: relative;
	width: 60px;
	max-height: 50px;

	&__dot {
		position: absolute;
		top: -10px;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background: #fff;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);
	}

	&__dot:nth-child(1) {
		left: 0;
		animation: lds-ellipsis1 1s infinite;
	}

	&__dot:nth-child(2) {
		left: 0;
		animation: lds-ellipsis2 1s infinite;
	}

	&__dot:nth-child(3) {
		left: 24px;
		animation: lds-ellipsis2 1s infinite;
	}

	&__dot:nth-child(4) {
		left: 48px;
		animation: lds-ellipsis3 1s infinite;
	}
}

@keyframes lds-ellipsis1 {
	0% {
		transform: scale(0);
	}
	100% {
		transform: scale(1);
	}
}

@keyframes lds-ellipsis3 {
	0% {
		transform: scale(1);
	}
	100% {
		transform: scale(0);
	}
}

@keyframes lds-ellipsis2 {
	0% {
		transform: translate(0, 0);
	}
	100% {
		transform: translate(24px, 0);
	}
}
</style>
